export default function (check) {
    if (check === true) {
        return "是"
    } else if (check === false) {
        return "否"
    }
}